import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AlertIcon } from 'assets/materialIcons/materialIcons';

const CancelModal = (props) => {
    const {
        modal,
        dialogDescription,
        dialogTitle,
        translate,
        closeDialog,
        dialogStatus,
        modalSubmit,
    } = props;

    const handleDialogSubmit = () => {
        modalSubmit();

        return closeDialog();
    };

    const actions = [
        <RaisedButton
            key='cancel'
            keyboardFocused={ true }
            label={ translate('actions.goBack') }
            onTouchTap={ closeDialog }
            style={ { marginRight: '20px' } }
        />,
        <RaisedButton
            backgroundColor={ theme.palette.redOrange }
            icon={ <AlertIcon /> }
            key='submit'
            label={ translate('actions.cancel') }
            labelColor={ theme.palette.white }
            onTouchTap={ handleDialogSubmit }
        />,
    ];

    return (
        <Dialog
            actions={ actions }
            actionsContainerStyle={ { padding: '0 24px 24px' } }
            contentStyle={ { maxWidth: '400px' } }
            modal={ modal }
            overlayStyle={ {
                backgroundColor: 'rgba(237, 236, 236, 0.6)',
            } }
            onRequestClose={ closeDialog }
            open={ dialogStatus }
            title={ dialogTitle }
        >
            { dialogDescription }
        </Dialog>
    );
};

CancelModal.propTypes = {
    modal: false,
};

CancelModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    dialogDescription: PropTypes.string,
    dialogStatus: PropTypes.bool.isRequired,
    dialogTitle: PropTypes.string,
    modalSubmit: PropTypes.func,
    translate: PropTypes.func,
};

export default translate(CancelModal);



// WEBPACK FOOTER //
// ./src/pages/bookings/show/actions/CancelModal.js